import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
export type Theme =
  | 'vs'
  | 'hc-black'
  | 'vs-dark'
  | 'AtlanticNight'
  | 'AtomOneDark'
  | 'AuroraX'
  | 'AyuDark'
  | 'AyuLight'
  | 'BlulocoLight'
  | 'CodeSandBox'
  | 'Darktooth'
  | 'Dracula'
  | 'EvaLight'
  | 'FlatUI'
  | 'Hopscotch'
  | 'HorlaLightTheme'
  | 'HybridNext'
  | 'KimbieDark'
  | 'Lucario'
  | 'MonokaiDimmed'
  | 'MonokaiPro'
  | 'Nebula'
  | 'NoctisAzureus'
  | 'NoctisBordo'
  | 'NoctisLux'
  | 'OneDarkPro'
  | 'OneMonokai'
  | 'Panda'
  | 'RemedyDark'
  | 'ReUI'
  | 'ShadesOfPurple'
  | 'SnazzyLight'
  | 'SnazzyOperator'
  | 'SublimeMaterialThemeDark'
  | 'SynthWave84'
  | 'TokyoNightStorm'
  | 'TomorrowNightBlue'
  | 'Twilight'
export type FoldingStrategy = 'auto' | 'indentation'
export type RenderLineHighlight = 'all' | 'line' | 'none' | 'gutter'
export type Language = 'javascript' | 'typescript' | 'html' | 'css' | 'json'
import type CodeEditor from '../code-editor.vue'
export interface Options {
  automaticLayout?: boolean // 自适应布局
  foldingStrategy?: FoldingStrategy // 折叠方式  auto | indentation
  renderLineHighlight?: RenderLineHighlight // 行亮
  selectOnLineNumbers?: boolean // 显示行号
  minimap?: {
    // 关闭小地图
    enabled: boolean
  }
  readOnly?: boolean // 只读
  fontSize?: number // 字体大小
  scrollBeyondLastLine?: boolean // 取消代码后面一大段空白
  overviewRulerBorder?: boolean // 不要滚动条的边框
}
export const defaultOptions = {
  automaticLayout: true,
  foldingStrategy: 'indentation',
  renderLineHighlight: 'all',
  selectOnLineNumbers: true,
  minimap: {
    enabled: true,
  },
  readOnly: false,
  fontSize: 16,
  scrollBeyondLastLine: false,
  overviewRulerBorder: false,
} as Options

export const codeEditorProps = buildProps({
  value: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  width: {
    type: [String, Number],
    default: '100%',
  },
  height: {
    type: [String, Number],
    default: '100%',
  },
  language: {
    type: definePropType<Language>(String),
    default: 'javascript',
  },
  theme: {
    type: definePropType<Theme>(String),
    default: 'vs',
  },
  options: {
    type: definePropType<Options>(Object),
    default: () => ({} as Options),
  },
} as const)

export const codeEditorEmits = {
  'update:value': (value: string) => !!value,
  change: (value: string) => !!value,
  'editor-mounted': (editor: any) => !!editor,
}

// props
export type CodeEditorProps = ExtractPropTypes<typeof codeEditorProps>

// emits
export type CodeEditorEmits = typeof codeEditorEmits

// instance
export type CodeEditorInstance = InstanceType<typeof CodeEditor>
